import React, { useState } from "react";
import { OPCIONES_SEXO, OPCIONES_EDAD } from "../../helper/userProfile";
import Button from "../Button/Button";
import "./PerfilUsuario.css";

const PerfilUsuario = ({ onContinuar }) => {
  const [sexo, setSexo] = useState("");
  const [edad, setEdad] = useState("");
  const [error, setError] = useState(false);

  const seleccionarSexo = (opcion) => {
    setSexo(opcion);
    setError(false);
  };

  const seleccionarEdad = (opcion) => {
    setEdad(opcion);
    setError(false);
  };

  const handleContinuar = () => {
    if (!sexo || !edad) {
      setError(true);
      return;
    }

    onContinuar({ sexo, edad });
  };

  return (
    <section className="perfil-usuario">
      <h1 className="perfil-title">Antes de empezar</h1>
      <p className="perfil-descripcion">
        Cuéntanos un poco de ti para orientarte mejor. Ambos campos son
        obligatorios.
      </p>

      <div className="perfil-grupo" role="group" aria-labelledby="perfil-sexo">
        <h2 className="perfil-label" id="perfil-sexo">
          Sexo <span className="perfil-obligatorio">Campo obligatorio</span>
        </h2>
        <div className="perfil-opciones">
          {OPCIONES_SEXO.map((opcion) => (
            <button
              key={opcion}
              type="button"
              className={`perfil-opcion ${sexo === opcion ? "seleccionada" : ""}`}
              aria-pressed={sexo === opcion}
              onClick={() => seleccionarSexo(opcion)}
            >
              {opcion}
            </button>
          ))}
        </div>
      </div>

      <div className="perfil-grupo" role="group" aria-labelledby="perfil-edad">
        <h2 className="perfil-label" id="perfil-edad">
          Edad <span className="perfil-obligatorio">Campo obligatorio</span>
        </h2>
        <div className="perfil-opciones">
          {OPCIONES_EDAD.map((opcion) => (
            <button
              key={opcion}
              type="button"
              className={`perfil-opcion ${edad === opcion ? "seleccionada" : ""}`}
              aria-pressed={edad === opcion}
              onClick={() => seleccionarEdad(opcion)}
            >
              {opcion}
            </button>
          ))}
        </div>
      </div>

      {error && (
        <p className="perfil-error" role="alert">
          Selecciona una opción en ambos campos para continuar.
        </p>
      )}

      <Button
        text={"Continuar"}
        className="agendar-cita"
        onClick={handleContinuar}
      />
    </section>
  );
};

export default PerfilUsuario;
